import './download-center.scss';
import { smoothScrollTo } from '../../utilities/js/helper';

class DownloadCenter {
    constructor (element) {
        this.$downloadCenter = element;
        this.$radioButtons = this.$downloadCenter.querySelectorAll('input[type="radio"]');
        this.ttl = 288000;
    }

    initialize () {
        if (this.$downloadCenter) {
            this.setIntitialStatus();
            this.submitForm();
        }
    }

    setStatus (key, value) {
        const now = new Date();
        const item = {
            value: value,
            expiry: now.getTime() + this.ttl
        };

        localStorage.setItem(key, JSON.stringify(item));
    }

    getStatus (key) {
        const itemStr = localStorage.getItem(key);

        if (!itemStr) {
            return null;
        }

        const item = JSON.parse(itemStr);
        const now = new Date();

        if (now.getTime() > item.expiry) {
            this.setStatus('status', 'category');
            return null;
        }

        return item.value;
    }

    setIntitialStatus () {
        const $getParameters = window.location.search;

        if ($getParameters.indexOf('?category=') === -1) {
            const status = this.getStatus('status');

            if (status && status !== 'language') {
                const $changedItem = this.$downloadCenter.querySelector('[data-download-center-item="' + status + '"]');

                if ($changedItem) {
                    const $itemsToReset = this.getSiblings($changedItem);

                    if ($itemsToReset.length > 0) {
                        let itemCount = 0;

                        for (let i = 0; i < $itemsToReset.length; i++) {
                            const $itemToReset = $itemsToReset[i];

                            if ($itemToReset.classList) {
                                if ($itemToReset.classList.contains('accordion__item')) {
                                    const $accordionHeaderText = $itemToReset.querySelector('[data-accordion="header"] strong');

                                    if ($accordionHeaderText) {
                                        $accordionHeaderText.remove();
                                    }
                                    const $accordionRadioButtons = $itemToReset.querySelectorAll('input[type="radio"]');

                                    for (let j = 0; j < $accordionRadioButtons.length; j++) {
                                        $accordionRadioButtons[j].checked = false;
                                    }

                                    if (itemCount === 0) {
                                        $itemToReset.querySelector('[data-accordion="header"]').click();
                                    } else {
                                        $itemToReset.classList.add('is--hidden');
                                    }
                                    itemCount++;
                                }
                            }
                        }

                        const $results = this.$downloadCenter.querySelector('[data-download-center-item="results"]');

                        if ($results) {
                            $results.classList.add('is--hidden');
                        }
                    }
                }
            }

            if (status) {
                let scrollToPosition = 0;
                if (status !== 'language') {
                    const $lastStatusItem = this.$downloadCenter.querySelector('[data-download-center-item="' + status + '"]');

                    if ($lastStatusItem !== null) {
                        const $nextStatusItem = $lastStatusItem.nextElementSibling;
                        if ($nextStatusItem) {
                            scrollToPosition = $nextStatusItem.offsetTop;
                        }
                    }
                } else {
                    const $results = this.$downloadCenter.querySelector('[data-download-center-item="results"]');
                    if ($results) {
                        scrollToPosition = $results.offsetTop;
                    }
                }

                smoothScrollTo(0, scrollToPosition, 500);
            }
        }
    }

    submitForm () {
        if (this.$radioButtons.length > 0) {
            for (let i = 0; i < this.$radioButtons.length; i++) {
                const $radioButton = this.$radioButtons[i];

                $radioButton.addEventListener('click', () => {
                    this.setStatus('status', $radioButton.name);
                    if (window.location.search !== '') {
                        const baseUrl = window.location.href.split('?')[0];
                        window.history.pushState('name', '', baseUrl);
                    }

                    this.$downloadCenter.submit();
                });
            }
        }
    }

    getSiblings (element) {
        const arraySib = [];

        while (element = element.nextSibling) { // eslint-disable-line
            arraySib.push(element);
        }
        return arraySib;
    }
}

export { DownloadCenter };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $downloadCenters = $context.querySelectorAll('[data-download-center]');
        if ($downloadCenters.length > 0) {
            for (let i = 0; i < $downloadCenters.length; i++) {
                const downloadCenterAPI = new DownloadCenter($downloadCenters[i]);
                downloadCenterAPI.initialize();
            }
        }
    }
});
